import React, { Component } from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { Pie } from 'react-chartjs-2';
import LoadingOverlay from './LoadingOverlay';

const PRODUCTION_STAGE_TIME_QUERY = gql`
  query StatsProductionStageTime {
    productionStageTime: stats_production_stage_time {
      projectId: project_id
      projectName: project_name
      stages {
        stageName: stage_name
        avgDays: avg_days
        count
      }
    }
  }
`;

const COLORS = [
  '#FF6384',
  '#36A2EB',
  '#FFCE56',
  '#4BC0C0',
  '#9966FF',
  '#FF9F40',
  '#FF6384',
  '#C9CBCF'
];

class ProductionStageTimeChart extends Component {
  render() {
    return (
      <Query query={PRODUCTION_STAGE_TIME_QUERY}>
        {({ loading, error, data }) => (
          <Card>
            <CardHeader>
              <strong>Average Production Time Between Stages (days)</strong>
            </CardHeader>
            <CardBody style={{ position: 'relative', minHeight: '200px' }}>
              {loading && <LoadingOverlay />}
              {error && <div>Error: {error.message}</div>}
              {!loading && !error && data && data.productionStageTime.map((project, idx) => {
                  const chartData = {
                    labels: project.stages.map(s => `${s.stageName} (${s.avgDays}d)`),
                    datasets: [{
                      data: project.stages.map(s => s.avgDays),
                      backgroundColor: COLORS.slice(0, project.stages.length),
                      hoverBackgroundColor: COLORS.slice(0, project.stages.length)
                    }]
                  };

                  const options = {
                    maintainAspectRatio: false,
                    legend: {
                      position: 'right',
                      labels: {
                        boxWidth: 12,
                        fontSize: 10
                      }
                    },
                    tooltips: {
                      callbacks: {
                        label: function(tooltipItem, data) {
                          const label = data.labels[tooltipItem.index];
                          const value = data.datasets[0].data[tooltipItem.index];
                          return `${label}: ${value} days`;
                        }
                      }
                    }
                  };

                  return (
                    <div key={idx} className={idx > 0 ? 'mt-4' : ''}>
                      <h6>{project.projectName}</h6>
                      <div style={{ height: '150px' }}>
                        <Pie data={chartData} options={options} />
                      </div>
                    </div>
                  );
                })}
            </CardBody>
          </Card>
        )}
      </Query>
    );
  }
}

export default ProductionStageTimeChart;



// WEBPACK FOOTER //
// ./src/views/Dashboard/ProductionStageTimeChart.js